<template>
    <div class="financial-list-page">
        <el-card shadow="never">
            <div slot="header" class="financial-list-page__header">
            
            
            
            
            
            
            
                <div class="financial-list-page__title-block">
                    <span class="financial-list-page__title">财务中心</span>
                </div>
                <div class="financial-list-page__toolbar">
                    <el-button size="small" icon="el-icon-download" @click="exportFinancials">导出财务</el-button>
                    <el-input
                        v-model.trim="keyword"
                        size="small"
                        clearable
                        placeholder="搜索订单号/公司名称/信用代码"
                        class="financial-list-page__search app-search-input"
                        @keyup.enter.native="fetchList"
                    >
                        <el-button slot="append" icon="el-icon-search" @click="fetchList" />
                    </el-input>
                </div>
            </div>

            <div class="financial-list-page__summary-groups">
                <div class="financial-list-page__group">
                    <div class="financial-list-page__group-title">客户侧回款</div>
                    <div class="financial-list-page__summary">
                        <div class="financial-list-page__metric">
                            <div class="financial-list-page__metric-label">订单数</div>
                            <div class="financial-list-page__metric-value">{{ summary.orderCount }}</div>
                        </div>
                        <div class="financial-list-page__metric financial-list-page__metric--accent">
                            <div class="financial-list-page__metric-label">应收总额</div>
                            <div class="financial-list-page__metric-value">￥{{ formatMoney(summary.receivableTotal) }}</div>
                        </div>
                        <div class="financial-list-page__metric">
                            <div class="financial-list-page__metric-label">已收总额</div>
                            <div class="financial-list-page__metric-value">￥{{ formatMoney(summary.paidTotal) }}</div>
                        </div>
                        <div class="financial-list-page__metric financial-list-page__metric--warn">
                            <div class="financial-list-page__metric-label">待收总额</div>
                            <div class="financial-list-page__metric-value">￥{{ formatMoney(summary.pendingTotal) }}</div>
                        </div>
                    </div>
                </div>
                <div class="financial-list-page__group">
                    <div class="financial-list-page__group-title">合作外勤（支出）</div>
                    <div class="financial-list-page__summary financial-list-page__summary--triple">
                        <div class="financial-list-page__metric">
                            <div class="financial-list-page__metric-label">应付合计</div>
                            <div class="financial-list-page__metric-value">￥{{ formatMoney(summary.fieldPayableTotal) }}</div>
                        </div>
                        <div class="financial-list-page__metric">
                            <div class="financial-list-page__metric-label">已付合计</div>
                            <div class="financial-list-page__metric-value">￥{{ formatMoney(summary.fieldPaidTotal) }}</div>
                        </div>
                        <div class="financial-list-page__metric financial-list-page__metric--warn">
                            <div class="financial-list-page__metric-label">待付合计</div>
                            <div class="financial-list-page__metric-value">￥{{ formatMoney(summary.fieldPendingTotal) }}</div>
                        </div>
                    </div>
                </div>
                <div class="financial-list-page__group">
                    <div class="financial-list-page__group-title">外派员工侧（支出）</div>
                    <div class="financial-list-page__summary financial-list-page__summary--triple">
                        <div class="financial-list-page__metric">
                            <div class="financial-list-page__metric-label">应付合计</div>
                            <div class="financial-list-page__metric-value">￥{{ formatMoney(summary.dispatchPayableTotal) }}</div>
                        </div>
                        <div class="financial-list-page__metric">
                            <div class="financial-list-page__metric-label">已付合计</div>
                            <div class="financial-list-page__metric-value">￥{{ formatMoney(summary.dispatchPaidTotal) }}</div>
                        </div>
                        <div class="financial-list-page__metric financial-list-page__metric--warn">
                            <div class="financial-list-page__metric-label">待付合计</div>
                            <div class="financial-list-page__metric-value">￥{{ formatMoney(summary.dispatchPendingTotal) }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <el-table
                :data="list"
                border
                stripe
                v-loading="loading"
                class="financial-list-page__table"
                :header-cell-style="{ textAlign: 'center' }"
            >
                <el-table-column prop="order_no" label="订单编号" min-width="168" fixed="left" show-overflow-tooltip />
                <el-table-column prop="company_name" label="公司名称" min-width="200" show-overflow-tooltip />
                <el-table-column prop="credit_code" label="统一信用代码" min-width="188" show-overflow-tooltip />
                <el-table-column label="应收" min-width="108" align="right">
                    <template slot-scope="{ row }">{{ formatMoney(row.receivable_total) }}</template>
                </el-table-column>
                <el-table-column label="已收" min-width="108" align="right">
                    <template slot-scope="{ row }">{{ formatMoney(row.paid_total) }}</template>
                </el-table-column>
                <el-table-column label="待收" min-width="108" align="right">
                    <template slot-scope="{ row }">{{ formatMoney(row.pending_amount) }}</template>
                </el-table-column>
                <el-table-column label="外勤应付" min-width="102" align="right">
                    <template slot-scope="{ row }">{{ formatMoney(row.field_payable_total) }}</template>
                </el-table-column>
                <el-table-column label="外勤已付" min-width="102" align="right">
                    <template slot-scope="{ row }">{{ formatMoney(row.field_paid_total) }}</template>
                </el-table-column>
                <el-table-column label="外勤待付" min-width="102" align="right">
                    <template slot-scope="{ row }">{{ formatMoney(row.field_pending_total) }}</template>
                </el-table-column>
                <el-table-column label="外派应付" min-width="102" align="right">
                    <template slot-scope="{ row }">{{ formatMoney(row.dispatch_payable_total) }}</template>
                </el-table-column>
                <el-table-column label="外派已付" min-width="102" align="right">
                    <template slot-scope="{ row }">{{ formatMoney(row.dispatch_paid_total) }}</template>
                </el-table-column>
                <el-table-column label="外派待付" min-width="102" align="right">
                    <template slot-scope="{ row }">{{ formatMoney(row.dispatch_pending_total) }}</template>
                </el-table-column>
                <el-table-column prop="pending_overdue_days" label="待收超期(天)" min-width="112" align="center" />
                <el-table-column label="颜色状态" min-width="96" align="center">
                    <template slot-scope="{ row }">
                        <el-tag :type="statusColorTagType(row.status_color)" size="mini" effect="plain">
                            {{ statusColorLabel(row.status_color) }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" min-width="108" fixed="right" align="center">
                    <template slot-scope="{ row }">
                        <el-button type="text" size="mini" @click="openDialog(row)">编辑财务</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <el-dialog title="编辑财务信息" :visible.sync="dialogVisible" width="560px">
            <el-form v-if="form" :model="form" label-width="120px">
                <el-form-item label="应收金额">
                    <el-input-number
                        v-model="form.receivable_total"
                        :min="0"
                        :precision="2"
                        :controls="false"
                        class="full-width"
                    />
                </el-form-item>
                <el-form-item label="已收金额">
                    <el-input-number
                        v-model="form.paid_total"
                        :min="0"
                        :precision="2"
                        :controls="false"
                        class="full-width"
                    />
                </el-form-item>
                <el-form-item label="待收金额">
                    <el-input-number
                        v-model="form.for_sale_amount"
                        :min="0"
                        :precision="2"
                        :controls="false"
                        class="full-width"
                    />
                </el-form-item>
                <el-form-item label="收款方式">
                    <el-select v-model="form.payment_type" class="full-width">
                        <el-option label="一次性" :value="1" />
                        <el-option label="分阶段" :value="2" />
                    </el-select>
                </el-form-item>
                <el-form-item label="待收起算时间">
                    <el-date-picker
                        v-model="form.receivable_initialized_at"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        class="full-width"
                    />
                </el-form-item>
                <el-form-item label="是否结清">
                    <el-switch v-model="expenseSettledFlag" active-text="已结清" inactive-text="未结清" />
                </el-form-item>
                <el-form-item label="结算状态">
                    <el-select v-model="form.settlement_status" class="full-width">
                        <el-option label="未结清" :value="0" />
                        <el-option label="已结清" :value="1" />
                    </el-select>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model.trim="form.remark" type="textarea" :rows="3" />
                </el-form-item>
                <el-alert
                    class="financial-list-page__form-hint"
                    title="外勤应付/已付、外派员工费用请在对应订单的「外勤」「派单」中修改。"
                    type="info"
                    :closable="false"
                    show-icon
                />
            </el-form>
            <span slot="footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" :loading="saving" @click="submitForm">保存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'FinancialList',
    data() {
        return {
            loading: false,
            saving: false,
            keyword: '',
            list: [],
            dialogVisible: false,
            currentOrderId: null,
            form: null
        };
    },
    created() {
        this.fetchList();
    },
    computed: {
        expenseSettledFlag: {
            get() {
                return this.form && this.form.is_expense_settled === 1;
            },
            set(value) {
                if (!this.form) {
                    return;
                }

                this.form.is_expense_settled = value ? 1 : 0;
                this.form.settlement_status = value ? 1 : 0;
            }
        },
        summary() {
            var orderCount = this.list.length;
            var receivableTotal = 0;
            var paidTotal = 0;
            var pendingTotal = 0;
            var fieldPayableTotal = 0;
            var fieldPaidTotal = 0;
            var fieldPendingTotal = 0;
            var dispatchPayableTotal = 0;
            var dispatchPaidTotal = 0;
            var dispatchPendingTotal = 0;

            for (var i = 0; i < this.list.length; i += 1) {
                var row = this.list[i] || {};
                receivableTotal += Number(row.receivable_total || 0);
                paidTotal += Number(row.paid_total || 0);
                pendingTotal += Number(row.pending_amount || 0);
                fieldPayableTotal += Number(row.field_payable_total || 0);
                fieldPaidTotal += Number(row.field_paid_total || 0);
                fieldPendingTotal += Number(row.field_pending_total || 0);
                dispatchPayableTotal += Number(row.dispatch_payable_total || 0);
                dispatchPaidTotal += Number(row.dispatch_paid_total || 0);
                dispatchPendingTotal += Number(row.dispatch_pending_total || 0);
            }

            return {
                orderCount: orderCount,
                receivableTotal: receivableTotal,
                paidTotal: paidTotal,
                pendingTotal: pendingTotal,
                fieldPayableTotal: fieldPayableTotal,
                fieldPaidTotal: fieldPaidTotal,
                fieldPendingTotal: fieldPendingTotal,
                dispatchPayableTotal: dispatchPayableTotal,
                dispatchPaidTotal: dispatchPaidTotal,
                dispatchPendingTotal: dispatchPendingTotal
            };
        }
    },
    methods: {
        formatMoney(value) {
            var amount = Number(value || 0);
            return amount.toFixed(2);
        },
        statusColorLabel(color) {
            var c = String(color || '').toLowerCase();
            if (c === 'red') {
                return '红';
            }
            if (c === 'yellow') {
                return '黄';
            }
            if (c === 'green') {
                return '绿';
            }
            return color || '--';
        },
        statusColorTagType(color) {
            var c = String(color || '').toLowerCase();
            if (c === 'red') {
                return 'danger';
            }
            if (c === 'yellow') {
                return 'warning';
            }
            if (c === 'green') {
                return 'success';
            }
            return 'info';
        },
        fetchList() {
            var _this = this;
            this.loading = true;

            window.axios.get('/financials', {
                params: {
                    keyword: this.keyword
                }
            }).then(function (response) {
                _this.list = response.data.data || [];
            }).catch(function () {
                _this.list = [];
                _this.$message.error('财务列表加载失败');
            }).finally(function () {
                _this.loading = false;
            });
        },
        openDialog(row) {
            this.currentOrderId = row.id;
            this.form = {
                receivable_total: Number(row.receivable_total || 0),
                paid_total: Number(row.paid_total || 0),
                for_sale_amount: Number(row.for_sale_amount != null ? row.for_sale_amount : row.pending_amount || 0),
                payment_type: row.payment_type || 1,
                is_expense_settled: row.is_expense_settled === 1 ? 1 : 0,
                settlement_status: row.expense_settlement_status === 1 ? 1 : 0,
                receivable_initialized_at: row.receivable_initialized_at || '',
                remark: row.remark || ''
            };
            this.dialogVisible = true;
        },
        exportFinancials() {
            window.axios.get('/exports/financials', {
                params: {
                    keyword: this.keyword || ''
                },
                responseType: 'blob'
            }).then(function (response) {
                var blobUrl = window.URL.createObjectURL(new Blob([response.data]));
                var link = document.createElement('a');
                link.href = blobUrl;
                link.download = 'financials-export.csv';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(blobUrl);
            });
        },
        submitForm() {
            var _this = this;
            this.saving = true;

            window.axios.put('/orders/' + this.currentOrderId + '/financial', this.form).then(function () {
                _this.$message.success('财务信息保存成功');
                _this.dialogVisible = false;
                _this.fetchList();
            }).catch(function (error) {
                var message = error && error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : '财务信息保存失败';
                _this.$message.error(message);
            }).finally(function () {
                _this.saving = false;
            });
        }
    }
};
</script>

<style scoped>
.financial-list-page {
    padding: 24px;
}

.financial-list-page__header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
    flex-wrap: wrap;
}

.financial-list-page__title-block {
    min-width: 0;
    flex: 1;
}

.financial-list-page__title {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
}

.financial-list-page__summary-groups {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 16px;
}

.financial-list-page__group-title {
    font-size: 13px;
    font-weight: 600;
    color: #606266;
    margin-bottom: 8px;
}

.financial-list-page__summary {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 12px;
}

.financial-list-page__summary--triple {
    grid-template-columns: repeat(3, minmax(0, 1fr));
}

.financial-list-page__metric {
    background: #f8fbff;
    border: 1px solid #e7eef8;
    border-radius: 8px;
    padding: 10px 12px;
}

.financial-list-page__metric--accent {
    background: #f0f9ff;
    border-color: #c6e2ff;
}

.financial-list-page__metric--warn {
    background: #fffbf0;
    border-color: #f5e0c3;
}

.financial-list-page__metric-label {
    font-size: 12px;
    color: #7c8ca2;
}

.financial-list-page__metric-value {
    margin-top: 6px;
    font-size: 17px;
    font-weight: 600;
    color: #1f2d3d;
}

.financial-list-page__toolbar {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
}

.financial-list-page__search {
    width: 300px;
}

.financial-list-page__table {
    width: 100%;
}

.full-width {
    width: 100%;
}

.financial-list-page__form-hint {
    margin-top: 12px;
}

@media (max-width: 1100px) {
    .financial-list-page__summary {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .financial-list-page__summary--triple {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (max-width: 560px) {
    .financial-list-page__summary,
    .financial-list-page__summary--triple {
        grid-template-columns: 1fr;
    }

    .financial-list-page__search {
        width: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/views/FinancialList.vue